/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_GeneratingInputs */

const cs_property_legal_generating = /** @type {(inputs: Property_Legal_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuji…`)
};

const en_property_legal_generating = /** @type {(inputs: Property_Legal_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating…`)
};

/**
* | output |
* | --- |
* | "Generating…" |
*
* @param {Property_Legal_GeneratingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_generating = /** @type {((inputs?: Property_Legal_GeneratingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_GeneratingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_generating(inputs)
	return cs_property_legal_generating(inputs)
});